import { createUseMutation } from 'api/common/createUseMutation'
import { updateUser } from 'api/fetchers/updateUser'
import { queryClient } from 'app/Root'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useUpdateUser = createUseMutation({
  fetcher: updateUser,
  onSettled: async () => {
    await queryClient.invalidateQueries({ queryKey: [ApiQueryKeys.MT_FILE_BY_ID] })
    await queryClient.invalidateQueries({ queryKey: [ApiQueryKeys.MT_USERS_ME] })
  },
})
